import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Server } from "lucide-react";
import { errMsg } from "../../lib/api";

export function DomainSetup({ api }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/domains/setup").then((r) => setS(r.data)).catch((e) => toast.error(errMsg(e))); }, [api]);
  if (!s) return null;
  const download = () => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([s.caddyfile], { type: "text/plain" }));
    a.download = "Caddyfile";
    a.click();
  };
  return (
    <div className="card-lux text-sm space-y-2" data-testid="admin-domain-setup">
      <h2 className="text-2xl text-[#062a20] flex items-center gap-2"><Server className="w-5 h-5" />Altiora domain proxy server</h2>
      <p data-testid="admin-domain-proxy-status">Status: {s.ready ? <b className="text-emerald-700">Configured</b> : <b className="text-amber-700">Not configured. Customers see "not switched on yet".</b>}
        {s.proxy_host && <> · host <code>{s.proxy_host}</code></>}{s.proxy_ips?.length > 0 && <> · IP <code>{s.proxy_ips.join(", ")}</code></>}</p>
      <p className="text-slate-600">Customer domains point to a small server you own. Caddy on that server gets and renews free HTTPS certificates automatically, keeps the customer's domain in the address bar, and forwards visits to your app at <code>{s.origin}</code>.</p>
      <ol className="list-decimal pl-5 space-y-1 text-slate-700" data-testid="admin-domain-steps">
        <li>Rent a small Linux server (Ubuntu, 1 GB RAM is enough) with a fixed public IPv4 address. Open ports 80 and 443.</li>
        <li>Install Caddy 2 (caddyserver.com/docs/install). Replace /etc/caddy/Caddyfile with the file below, put in your email, then run <code>sudo systemctl reload caddy</code>.</li>
        <li>In your altiora.ventures DNS, add an A record <code>edge</code> pointing to the server's IP (DNS only, not proxied).</li>
        <li>Set DOMAIN_PROXY_HOST=<code>edge.altiora.ventures</code> and DOMAIN_PROXY_IPS=<code>the server IP</code> in the app settings, then republish.</li>
      </ol>
      <button onClick={download} className="chip !text-xs" data-testid="admin-domain-caddyfile">Download Caddyfile</button>
    </div>);
}
